import { withStyles } from '@material-ui/core/styles';
import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import 'react-virtualized/styles.css';
import { VALUATION_FORM_HEADERS } from '../../enums/formHeaders';
import ImageCarousel from '../ImageCarousel';
import { OrderReviewContext } from './OrderReviewContext';

function FormHeaderImages({ showHiddenImages }) {
  const { state } = useContext(OrderReviewContext);
  const formHasImages = state.formHeaders[state.activeFormHeaderIndex].formDefinitions?.filter(fd => fd.questionCategoryId === 1).flatMap(fd => fd.answers).flatMap(a => a.images).length > 0; //state.formHeaders[state.activeFormHeaderIndex].images?.length > 0;
  const formHasValuation = VALUATION_FORM_HEADERS.includes(state.formHeaders[state.activeFormHeaderIndex].formHeaderId);

  return (
    formHasImages && (
      <ImageCarousel
        images={state.formHeaders.filter(fh => fh.images).flatMap(fh => fh.images)
          .filter(fhi => state.formHeaders[state.activeFormHeaderIndex].formDefinitions
                         .filter(fd => fd.questionCategoryId === 1)
                         .flatMap(fd => fd.answers)
                         .flatMap(a => a.images)
                         .some(i => (showHiddenImages || !i.hideImage) && i.formQaImageId == fhi.formQaImageId)).sort(i => i.formQaImageId)
              .map(image => {
                image.src = image.imageUri.replace('fieldrepimage', 'fieldrepimagelarge').replace('/raw/', '/large/');
                return image;
              })}
        getBadgeContent={image =>
          state.formHeaders
            .filter(fh => fh.formDefinitions)
            .map(fh =>
              fh.formDefinitions.filter(
                fd =>
                  fd.answerType !== 'Picture' &&
                  fd.answers &&
                  fd.answers.length > 0 &&
                  fd.answers.some(
                    a =>
                      a.images &&
                      a.images.length > 0 &&
                      a.images.some(i => i && i.formQaImageId === image.formQaImageId),
                  ),
              ),
            )
            .flat().length
        }
        onClick={function scrollToImage({ formQaImageId }) {
          let element = document.getElementById(`scroll-to-id-${formQaImageId}`);
          let container = document.getElementById('images-container');
          // const scrollElement = formHasValuation ? container.parentElement : container;
          const scrollElement = container;
          const offsetTop = element.offsetTop;

          scrollElement.scroll({
            top: offsetTop - 245,
            behavior: 'smooth',
          });
        }}
      />
    )
  );
}

const styles = theme => ({});
FormHeaderImages.propTypes = {};
export default withStyles(styles)(withRouter(FormHeaderImages));
